import React from "react";

const GeoPromptsLoader = () => {
    return(
        <div className="geo_item_overview_cont_item_cont_loader">
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
            <div className="geo_item_overview_cont_item_cont_item_loader fade-in"></div>
        </div>
    )
}

export default GeoPromptsLoader